import * as React from "react";
import "@aurodesignsystem/auro-input";
import "../OtsForm/AddOTSForm.scss";
import "@aurodesignsystem/auro-select";
import "@aurodesignsystem/auro-menu";
import "@aurodesignsystem/auro-combobox";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  getAircraftAndEtopsIndicatorList,
  getLocation,
} from "../../services/otsEventService";
import { useEffect, useRef } from "react";
import Badge from "../Badge/Badge";
import { useAtaCodes } from "../../providers/AtaCodeProvider";
import { useAuthentication } from "meportal/AuthenticationProvider";
import { useEventType } from "../../providers/EventTypeProvider";
import { AuthorizationAccessCheck, IsAuthorized, useAuthorization } from "meportal/AuthorizationProvider";
import { CreateButton } from "../../constants/PermissionSet";
import * as Constants from "../../constants/Constants";
import { useToast } from '../../providers/ToastProvider';
import { NOTIFICATION_TYPES } from '../ToastNotification/toastConstants';
import { EventType } from "../../Models/EventType";
import { useInlineNotification } from "../../providers/InlineNotificationProvider";

import { INLINE_NOTIFICATION_TYPES } from '../InlineNotification/inlineNotificationConstants';

interface AddOTSFormProps {
  setAircraftATA: React.Dispatch<React.SetStateAction<string>>;
  setAircraftNumber: React.Dispatch<React.SetStateAction<string>>;
  onAddOTS: (otsevent: OtsEvent) => void;
    cancelbox: boolean;
  setOnTailValidChange: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function AddOTSForm(props: AddOTSFormProps) {
  const { eventTypes, selectedEventType, isEventTypeHttpError } = useEventType();
  const { eventPermissions, userClaims } = useAuthorization();
  const eventTypeRef = useRef(null);
  const { onAddOTS, setAircraftATA, setAircraftNumber, setOnTailValidChange } = props;
  const { userData, getLatestAccessToken } = useAuthentication();
  const [filteredEventTypes, setFilteredEventTypes] = React.useState<any[]>([]);
  const [resetEventTypeDropdown, setResetEventTypeDropdown] = React.useState(false);
  const [eventType, setEventType] = React.useState(null);
  const [eventTypeCategory, setEventTypeCategory] = React.useState("");
  const [isEventTypeValid, setIsEventTypeValid] = React.useState(false);
  const [isEventTypeTouched, setIsEventTypeTouched] = React.useState(false);
  const [tailNumber, setTailNumber] = React.useState("");
  const [isTailValid, setIsTailValid] = React.useState(false);
  const [isErrorTail, setShowErrorTail] = React.useState(false);
  const [validAircraftList, setValidAircraftList] = React.useState<AircraftandEtopsIndicator[]>([]);
  const [etops, setEtops] = React.useState(false);
  const [station, setStation] = React.useState("");
  const [isStationValid, setIsStationValid] = React.useState(false);
  const [location, setLocation] = React.useState("");
  const [isLocationValid, setLocationValid] = React.useState(true);
  const [ataCode, setSelectedATACode] = React.useState("");
  const [ataCodeDescription, setATACodeDescription] = React.useState("");
  const [isATAValid, setisATAValid] = React.useState(false);
  const { ataCodes, isAtaCodeHttpError } = useAtaCodes();
  const [isAdvEtrValid, SetIsAdvEtrValid] = React.useState(false);
  const [isErrorAdvEtr, setShowErrorAdvEtr] = React.useState("");
  const [problemText, setProblemText] = React.useState("");
  const [problemTextCount, setProblemTextCount] = React.useState(0);
  const [isProblemTextValid, setIsProblemTextValid] = React.useState(false);
  const[ATAError,setATAError]=React.useState(false);
  const [advtime, setAdvTime] = React.useState<Date | null>(
    null
  );
  const [etrtime, setEtrTime] = React.useState<Date | null>(
    null
  );
  const [alreadyOTS, setAlreadyOTS] = React.useState(false);
  const [isForAirborneEventObject, setIsForAirborneEventObject] = React.useState<EventType | null | undefined>(null);
  
  const { addToast } = useToast();
  
  const { addInlineNotification, removeInlineNotification } = useInlineNotification();

  const [attempts, setAttempts] = React.useState(0);
  const totalAttempts = 3;
  const attemptsRef = React.useRef(attempts);

  useEffect(() => {
    if (isAtaCodeHttpError) {
      addToast(NOTIFICATION_TYPES.WARNING, 'Unable to retrieve ATA codes.', 'Please try again.');
    }
  }, [isAtaCodeHttpError]);

  useEffect(() => {
    if (isEventTypeHttpError) {
      addToast(NOTIFICATION_TYPES.WARNING, 'Unable to load event type.', 'Please try again.');
    }
  }, [isEventTypeHttpError]);

  useEffect(() => {
    const control = eventTypeRef.current;
    const handleSelectedOption = (elem) => {
      setEventType(elem.target.value);
      let matchingItem = filteredEventTypes.find(item => item.Name === elem.target.value);
      console.log("Set the event type to: ", matchingItem);
      if (matchingItem) {
        setEventTypeCategory(matchingItem.Category);
        setIsEventTypeValid(true);
      }
    };

    if (control) {
      control.addEventListener('selectedOption', handleSelectedOption);
    }

    // Clean up function
    return () => {
      if (control) { control.removeEventListener('selectedOption', handleSelectedOption); }
    };
  }, [filteredEventTypes, resetEventTypeDropdown]);

  useEffect(() => {
    validateForm();
  }, [
    eventType,
    eventTypeCategory,
    tailNumber,
    etops,
    station,
    isStationValid,
    location,
    ataCode,
    advtime,
    etrtime,
    isAdvEtrValid,
    problemText,
    isEventTypeValid,
    isLocationValid
  ]);
 


  useEffect(() => {

    async function getAircraftdata() {
      let validAircraftList: AircraftandEtopsIndicator[] = [];
      getLatestAccessToken().then((token) => {
        userData.access_token = token;
        getAircraftAndEtopsIndicatorList(userData).then((list) => {
          const filteredAircraftList = list.map((item) =>
            removeStartingChar(item)
          );
          validAircraftList = filteredAircraftList;
          setValidAircraftList(validAircraftList);
        }).catch((error: any) => {
          addToast(NOTIFICATION_TYPES.WARNING, 'Unable to load aircraft data.', 'Please try again.');
          console.log("getAircraftAndEtopsIndicatorList error: ", error);
        });
      });
    }
    getAircraftdata();

  }, [userData]);

  function removeStartingChar(item: any) {
    if (item.Tail.charAt(0) === "N") {
      item.Tail = item.Tail.substring(1);
    }
    return item;
  }

  const handleAirbourne = (data:any) => {
        var airline = userData?.profile?.company; 
        if (airline === "QX") // for Horizon, the Airborne status is not restricted.  Allow any selection
        {
            setLocation(data.Location);
            loadEventTypes(eventTypes);
            CreatePermissionCheckForToasts(eventTypes);
        }
        else if (data?.IsAirborne) {
            const airborneEvent = Array.isArray(eventTypes) ? eventTypes.find(eventType => eventType.Category == "NotApplicable" && eventType.IsForAirborne && eventType.IsActive) : null;
            setLocation(airborneEvent? airborneEvent.Name.slice(0, 10) : "");
            setIsForAirborneEventObject(airborneEvent);
            const isAirborneAuthorized = CreatePermissionCheckForIsAirborne(airborneEvent);
            // filter out the event types that are not for airborne
            const filteredEventTypes = Array.isArray(eventTypes) ? eventTypes.filter(eventType => !eventType.IsForAirborne): [];
            if(isAirborneAuthorized){
              loadEventTypes(filteredEventTypes);
            }
            else{
              loadEventTypes([]);
            }
            CreatePermissionCheckForToasts(filteredEventTypes);
        }
        else if (!data?.IsAirborne) {
            setLocation(data.Location);
            const filteredEventTypes = Array.isArray(eventTypes) ? eventTypes.filter(eventType => eventType.Category != "NotApplicable" && !eventType.IsForAirborne) : [];
            loadEventTypes(filteredEventTypes);
            CreatePermissionCheckForToasts(filteredEventTypes);
        }
    }


  const CreatePermissionCheckForToasts = (events: any) => {
    // Check if events is an array and if its length is 0
    if (!Array.isArray(events) || events.length === 0) {
      addToast(NOTIFICATION_TYPES.WARNING, "You do not have permission to create this event.", "Please contact a MOM.");
      return;
    }
    // Check if all items are unauthorized
    const allUnauthorized = events.every(item => !IsAuthorized(item.Airline + ":" + item.Name, CreateButton, eventPermissions, userClaims));
    if (allUnauthorized) {
      addToast(NOTIFICATION_TYPES.WARNING, "You do not have permission to create this event.", "Please contact a MOM.");
    }
  }

  const CreatePermissionCheckForIsAirborne = (airborneEvent: any) => {
    if(!airborneEvent){
      addToast(NOTIFICATION_TYPES.WARNING, "Airborne event not found.", "Please contact a MOM.");
      return false;
    }
    if (airborneEvent && !IsAuthorized(airborneEvent.Airline + ":" + airborneEvent.Name, CreateButton, eventPermissions, userClaims)) {
      addToast(NOTIFICATION_TYPES.WARNING, `You do not have permission to create ${airborneEvent.Name} event.`, "Please contact a MOM.");
      return false;
    }
    return true;
  }

  const handleAircraft = (event: any) => {
    if (!event.target.value) {
      event.target.value = "";
    }
    const inputTail = event.target.value.toUpperCase();
    setTailNumber(inputTail);
    setEtops(false);      
    let result = validAircraftList.find((e) => e.Tail === inputTail);
    let isAlreadyOTS = validAircraftList.some((e) => e.Tail === inputTail && e.IsOutOfService === true);
    if (!result || isAlreadyOTS) {
      event.target.validity = "customError";
      event.target.isValid = false;
      event.target.__errorMessage = "Enter a valid Aircraft#";
      setShowErrorTail(true);
      setIsTailValid(false);
      setAlreadyOTS(isAlreadyOTS);
      setIsForAirborneEventObject(null);
      setStation("");
      setLocation("");
      //resetting the event types dropdown to empty for invalid tail number
      loadEventTypes([]);
    }
    else {
      //calling event types and setting the event types dropdown based on the airborne status
      console.log("About to to call the getLatestAccessToken function");
      
      setShowErrorTail(false);
      setIsTailValid(true);
      setAlreadyOTS(false);
      let etopsCapability = validAircraftList.find((e) => e.Tail === tailNumber)?.Etops;
      if (etopsCapability === true) {

        setEtops(etopsCapability);
      }
      // getStation(userData, tailNumber).then((data) => {
      //   console.log("Station/Location data: ", data);
      //   // let resp = data === null ? "" : data;
      //   setStation(data.Station);
      //   if (data.Station !== "")
      //     setIsStationValid(true);
      //   setLocation(data.Location);
      // });
    }
  }

  const loadEventTypes = (filteredEventTypes: any[]) => {
    setFilteredEventTypes(filteredEventTypes);
    setEventType(null);
    setEventTypeCategory("");
    setIsEventTypeValid(false);
    setResetEventTypeDropdown(prevKey => !prevKey);
  };

  const handleStationValue = (event: any) => {
    setStation(event.target.value.toUpperCase());
    if(event.target.value.length == 3 && event.target.value.match(/^[a-zA-Z]{3}$/)) {
      setIsStationValid(true);
    } else {
      setIsStationValid(false);
    }
  };

  //Adding refs for the minute calculation
  const advtimeRef = useRef(advtime);
  const etrtimeRef = useRef(etrtime);

  useEffect(() => {
    advtimeRef.current = advtime;
    etrtimeRef.current = etrtime;
  }, [advtime, etrtime]);

  useEffect(() => {
    // Check if advTime/etrTime is in the future
    const checkAdvEtr = () => {
      const currentDateTime = new Date();

      if ((advtimeRef.current && !etrtimeRef.current) || (etrtimeRef.current && !advtimeRef.current)) {
        if ((advtimeRef.current && advtimeRef.current < currentDateTime) || (etrtimeRef.current && etrtimeRef.current < currentDateTime)) {
          // Show error if advTime/etrTime is in the future
          setShowErrorAdvEtr("ADV/ETR can not be in the past");
          SetIsAdvEtrValid(false);
        }
      }
    };

    // Calculate time until next minute
    const now = new Date();
    const delay = 60 - now.getSeconds();

    // run check on the exact minute change
    const timeout = setTimeout(() => {
      console.log("before 1st min:", new Date());
      checkAdvEtr();

      // Then update advTime every minute
      const interval = setInterval(() => {
        console.log("before each min:", new Date());
        checkAdvEtr();
      }, 60000); // run each minute
      return () => {
        console.log("clearing interval");
        clearInterval(interval);
      };
    }, delay * 1000);
    return () => {
      console.log("clearing timeout");
      clearTimeout(timeout);
    };
  }, []);

  const handleAdvTimeChange = (adv: Date | null) => {
    setShowErrorAdvEtr("");
    SetIsAdvEtrValid(true);
    setAdvTime(adv);

    const currentDateTime = new Date();
    // Check if advTime is in the future
    if (adv && adv < currentDateTime) {
      // Show error if advTime is in the future
      setShowErrorAdvEtr("ADV/ETR can not be in the past");
      SetIsAdvEtrValid(false);
    }

    if (adv !== null) {
      setEtrTime(null);
    } else {
      if (etrtime === null) {
        setShowErrorAdvEtr("Enter a valid ADV/ETR");
        SetIsAdvEtrValid(false);
      }
    }
  };

  const handleEtrTimeChange = (etr: Date | null) => {
    setShowErrorAdvEtr("");
    SetIsAdvEtrValid(true);
    setEtrTime(etr);

    const currentDateTime = new Date();
    // Check if etrTime is in the future
    if (etr && etr < currentDateTime) {
      // Show error if advTime is in the future
      setShowErrorAdvEtr("ADV/ETR can not be in the past");
      SetIsAdvEtrValid(false);
    }

    if (etr !== null) {
      setAdvTime(null);
    } else {
      if (advtime === null) {
        setShowErrorAdvEtr("Enter a valid ADV/ETR");
        SetIsAdvEtrValid(false);
      }
    }
  };

  const handleInvalidDate = (error: any) => {
    if (error !== null) {
      if(error === "disablePast"){
        setShowErrorAdvEtr("ADV/ETR can not be in the past");
      }
      else{
        setShowErrorAdvEtr("Enter a valid ADV/ETR");
      }
      SetIsAdvEtrValid(false);
    }
  };

  const handleProblemTextValue = (event: any) => {
    const inputValue = event.target.value;
     // Strip HTML from the input value
    let strippedValue = stripHtmlTags(inputValue);
    // Remove any characters that don't match the pattern
    const sanitizedProblem = strippedValue.replace(Constants.PROBLEMTEXT_LOCATION_REGEX_REPLACE, '');

    if (Constants.PROBLEMTEXT_LOCATION_REGEX_PATTERN.test(sanitizedProblem)) {
        event.target.value = sanitizedProblem;
        setProblemText(sanitizedProblem);
        setProblemTextCount(sanitizedProblem.length);
        setIsProblemTextValid(sanitizedProblem.length > 0);
    }
};

const handleLocation = (event: any) => {
  const inputValue = event.target.value;
   // Strip HTML from the input value
  let strippedValue = stripHtmlTags(inputValue);
  // Remove any characters that don't match the pattern
  const sanitizedLocation = strippedValue.replace(Constants.PROBLEMTEXT_LOCATION_REGEX_REPLACE, '');

  if (Constants.PROBLEMTEXT_LOCATION_REGEX_PATTERN.test(sanitizedLocation)) {
      event.target.value = sanitizedLocation;
      setLocation(sanitizedLocation);
      setLocationValid(event.target.isValid);
  } 
};

  let isoDateString = new Date().toISOString();
  const state = { currentDateTime: isoDateString };

    const handleATaonBlur = (event: any) => {
        let result = Array.isArray(ataCodes)
            ? ataCodes.map((e) => e.ChapterCode).includes(ataCode) : null;
        if (ataCode.length == 0) {
            setisATAValid(false);
            setATAError(true);
        }
        else if (!result || (ataCode.length < 2 && ataCode.length > 0)) {
            event.target.validity = "customError";
            event.target.isValid = false;
            event.target.__errorMessage = "Enter a valid ATA code";
            setATACodeDescription("");
            setisATAValid(false);
            setATAError(true);
        }
        else {
            let atadescription = Array.isArray(ataCodes) ? ataCodes.find((e) => e.ChapterCode === ataCode)?.Description || "" : "";
            setisATAValid(true);
            setATAError(false);
            setATACodeDescription(atadescription);
        }
       
    }

    const handleATAcode = (event: any) => {
        const { key } = event;
        if ((key >= '0' && key <= '9') || key == 'Backspace' || key == 'Tab' || key == 'ArrowLeft' || key == 'ArrowRight') { 
            const atacode = event.target.value;
            setSelectedATACode(atacode);
            setAircraftATA(atacode);
            let result = Array.isArray(ataCodes)
                ? ataCodes.map((e) => e.ChapterCode).includes(atacode) : null;
            if (atacode.length == 0) {
                setisATAValid(false);
                setATAError(true);
            }
            else if (!result || (atacode.length < 2 && atacode.length > 0)) {
                event.target.validity = "customError";
                event.target.isValid = false;
                event.target.__errorMessage = "Enter a valid ATA";
                setATACodeDescription("");
                setisATAValid(false);
                setATAError(true);
            }
            else {
                let atadescription = Array.isArray(ataCodes) ? ataCodes.find((e) => e.ChapterCode === atacode)?.Description || "" : "";
                setisATAValid(true);
                setATAError(false);
                setATACodeDescription(atadescription);
            }
        }
        else {
            event.preventDefault();
        }
      }

  const validateForm = () => {
    if (isEventTypeValid && isTailValid && isStationValid && isProblemTextValid && isATAValid && isAdvEtrValid && isLocationValid) {
      //valid form
      dataSubmission(false);
    } else {
      //invalid form
      dataSubmission(true);
    }
  };

  React.useEffect(() => {
    setAircraftNumber(tailNumber);
  }, [tailNumber]);

  React.useEffect(() => {
    setAircraftATA(ataCode);
  }, [ataCode]);

  useEffect(() => {
    attemptsRef.current = attempts;
  }, [attempts]);

  const getLocationData = React.useCallback(async (userData, tailNumber) => {
    try {
      const data = await getLocation(userData, "N" + tailNumber);
      handleAirbourne(data);
      setStation(data.Station);
      console.log("Station/Location data: ", data);
      removeInlineNotification();
      setAttempts(0);
    } catch (error) {
      console.error("An error occurred while checking airborne status: ", error);
      throw error;
    }
  }, [removeInlineNotification]);

  const getFailureDescription = (attemptsCount: any) => {
    const remainingAttempts = totalAttempts - attemptsCount;
    return remainingAttempts > 0
      ? `You have ${remainingAttempts}/${totalAttempts} remaining attempts to retry retrieving station and location data.`
      : 'You reached the max retry attempt. Please exit this screen and try again later.';
  };

  const handleTryAttempts = React.useCallback(async () => {
    const newAttempts = attemptsRef.current + 1;
    setAttempts(newAttempts);

    if (newAttempts <= totalAttempts) {
      try {
        const token = await getLatestAccessToken();
        userData.access_token = token;
        await getLocationData(userData, tailNumber);
      } catch (error) {
        const remainingAttempts = totalAttempts - newAttempts;
        
        addInlineNotification(
          'warning',
          'Unable to retrieve station and location data.',
          getFailureDescription(newAttempts),
          '',
          remainingAttempts > 0 ? handleTryAttempts : undefined,
          newAttempts
        );

        loadEventTypes([]);
      }
    }
  }, [addInlineNotification, getLocationData, tailNumber]);

  useEffect(() => {
    if (tailNumber && tailNumber.length >= 5) {
      console.log("Input Tail for Location", tailNumber);
      // Check if tailNumber exists in validAircraftList
     const isValidTailNumber = validAircraftList.some(
         (aircraft) => aircraft.Tail === tailNumber
      );

     if (!isValidTailNumber) {
        setOnTailValidChange(false);
        loadEventTypes([]); // Reset event types dropdown
         return;
      }
      setOnTailValidChange(true);
            // Proceed with API call if tailNumber is valid
      getLatestAccessToken().then((token) => {
        userData.access_token = token;
        getLocationData(userData, tailNumber).catch((error) => {
          addInlineNotification(
            'warning',
            'Unable to retrieve station and location data.',
            getFailureDescription(0),
            '',
            handleTryAttempts,
            0
          );
          loadEventTypes([]);
        });
      });
    }
  }, [isTailValid, tailNumber, getLocationData, handleTryAttempts, validAircraftList, setOnTailValidChange]);
 
  
  const stripHtmlTags = (input: string) => {
    const doc = new DOMParser().parseFromString(input, 'text/html');
    return doc.body.textContent || "";
  };

  const dataSubmission = (isValidForm: boolean) => {
     let otsEventData: OtsEvent = {
      isSubmitDisabled: isValidForm,
      action: "ADD",
      tail: "N" + tailNumber,
      subAction: "",
      airline: "",
      ATACode: ataCode,
      ataCodeDescription: ataCodeDescription,
      station: station,
      location: location,
      problemText: problemText,
      eventType: isForAirborneEventObject? isForAirborneEventObject.Name : eventType,
      eventTypeCategory: isForAirborneEventObject? isForAirborneEventObject.Category: eventTypeCategory,
      eventTypeTo: isForAirborneEventObject ? eventType : "",
      eventTypeCategoryTo: isForAirborneEventObject ? eventTypeCategory : "",
      adviseTime:
        advtime !== null && !isNaN(advtime.getTime())
          ? advtime?.toISOString()
          : null,
      etrTime:
        etrtime !== null && !isNaN(etrtime.getTime())
          ? etrtime?.toISOString()
          : null,
      outOfServiceTime: state.currentDateTime,
      isEtopsCapable: etops.toString(),
      HasPublicAttachment: false
    };
   

   
    onAddOTS(otsEventData);
  };
  
  return (
    <div>
      {/* <div className="drpdwn-unschd-ots">
                <auro-select class="txtotsevent" ref={eventTypeRef} value={eventType}  required 
                            setCustomValidityValueMissing="An event type selection is required" >
                    <auro-menu class="txtotsevent">
                      {Array.isArray(eventTypes) &&
                          eventTypes?.map((item: any) => (
                          item.IsActive ? (
                          <AuthorizationAccessCheck eventId={item.Airline + ":" + item.Name} permission={CreateButton}> 
                            <auro-menuoption value={item.Name}
                                                key={item.Name}
                                                id={item.Name}
                              >{item.Name}</auro-menuoption>
                            </AuthorizationAccessCheck>  
                          ) : null
                      ))}
                    </auro-menu>
                </auro-select>
            </div> */}
      <span className="create-event-details">Event Details <span className="asterik">*</span></span>
      <div className="create-event-details-input-list">
        <div className="input-list">
          <div className={!props.cancelbox && validAircraftList != null ? "form-input dropdown" : "form-input"}>
            <auro-combobox className="auro-size"
              data-testid="aircraft-number"
              required
              setCustomValidity=" "
              validateOnInput
              activeLabel="true"
              bordered
              value={tailNumber}
              onBlur={handleAircraft}
              onInput={handleAircraft}>
              <span slot="label">Aircraft {etops ? <div className="badge-create-container"><span className="badge-data create"><Badge data="E" /></span></div> : ""}</span>
              <auro-menu>
                {validAircraftList.map((aircraft, index) => (
                  <auro-menuoption value={aircraft.Tail} id={index.toString()} key={index}>{aircraft.Tail}</auro-menuoption>
                ))}
                <auro-menuoption static nomatch>No matching option</auro-menuoption>
              </auro-menu>
            </auro-combobox>
            {isErrorTail && alreadyOTS && tailNumber != "" && <div className="dateTimeError">This aircraft is already out of service</div>}
            {isErrorTail && !alreadyOTS && tailNumber != "" && <div className="dateTimeError">Enter a valid Aircraft#</div>}
            {isErrorTail && tailNumber == "" && <div className="dateTimeError">Please fill out this field.</div>}
          </div>
          <div className="form-input">
            <auro-input
              data-testid="station"
              required
              validateOnInput
              bordered
              maxlength="3"
              minLength="3"
              pattern="[a-zA-Z]{3}"
              setCustomValidity="Enter a valid station"
              onInput={handleStationValue}
              value={station}>
              <span slot="label">Station</span>
            </auro-input>
          </div>
          <div className="form-input">
            <auro-input
            data-testid="location"
            validateOnInput
            setCustomValidity="Enter location within 10 chars"
            disabled={isForAirborneEventObject}
            class={isForAirborneEventObject ? "disabled-create-location-input" : ""}
              bordered
            maxlength="10"
              value={location}
              onInput={handleLocation}>
              <span slot="label">Loc</span>
            </auro-input>
          </div>
          <div className="form-input">
            <auro-input
              data-testid="ata-code"
              required
              validateOnInput
              bordered
                          maxLength={"2"}
                          setCustomValidity=" "
                          value={ataCode}
              onKeyUp={handleATAcode}
                          onBlur={(e) => { handleATaonBlur(e) }}
              onKeyDown={(e) => {
                  handleATAcode(e);
                          }}>
              

              <span slot="label">ATA</span>
                      </auro-input>
                      {ataCode == "" && ATAError && < div className="dateTimeError" >Please fill out this field</div>}
                      {ataCode != "" && ATAError && < div className="dateTimeError">Enter a valid ATA</div>}
                  </div>
        </div>
        <div className="adv-etr-container">
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <div className="form-input-create">
              <DateTimePicker
                data-testid="adv-date-time-picker"
                label="ADV"
                ampm={false}
                format="HH:mm MM/dd/yyyy"
                timeSteps={{ minutes: 15 }}
                value={advtime}
                onChange={handleAdvTimeChange}
                onError={handleInvalidDate}
                disablePast={true}
              />
              {!isAdvEtrValid && <div className="dateTimeError">{isErrorAdvEtr}</div>}
            </div>
            <div className="form-input-create">
              <DateTimePicker
                data-testid="edv-date-time-picker"
                label="ETR"
                ampm={false}
                format="HH:mm MM/dd/yyyy"
                timeSteps={{ minutes: 15 }}
                value={etrtime}
                onChange={handleEtrTimeChange}
                onError={handleInvalidDate}
                disablePast={true}
              />
            </div>
          </LocalizationProvider>
           <div className="form-input-create">
          <auro-select 
        data-testid="event-type-dropdown" 
        ref={eventTypeRef} 
        value={eventType} 
        key={resetEventTypeDropdown} 
        required
        validateOnInput
        bordered
        error={!isEventTypeValid &&  isEventTypeTouched ? "Enter a valid event type" : null}
        onInput={(e) => {
          const select = eventTypeRef.current;
          if (select) {
            if (e.target.value && isStationValid) {
              setIsEventTypeValid(true);
            } else {
              setIsEventTypeValid(false);
            }
            select.reportValidity();
          }
        }}
        onBlur={() => setIsEventTypeTouched(true)}
      >
        <span slot="label">Event Type</span>
        <auro-menu>
          {Array.isArray(filteredEventTypes) &&
            filteredEventTypes?.map((item: any) => (
              item.IsActive ? (
                <AuthorizationAccessCheck key={item.Name} eventId={item.Airline + ":" + item.Name} permission={CreateButton}>
                  <auro-menuoption 
                    value={item.Name}
                    id={item.Name}
                  >
                    {item.Name}
                  </auro-menuoption>
                </AuthorizationAccessCheck>
              ) : null
            ))}
        </auro-menu>
</auro-select>
    </div>





        </div>
        <div className="problem-container">
          <auro-input
            data-testid="problem-statement"
            className="problem-statement"
            required
            validateOnInput
            bordered
            maxlength="80"
            setCustomValidity="Enter valid problem statement"
            placeholder="Enter problem statement"
            value={problemText}
            onInput={handleProblemTextValue}>
            <span slot="label">Problem Statement</span>
            <span slot="helptext">{problemTextCount > 0 ? `${problemTextCount} characters (maximum 80 characters)` : "maximum 80 characters"}</span>
          </auro-input>
        </div>
      </div>
    </div>
  );
}
